const videoList = [
    {
        url: 'http://img.sportscv.cn/video/%EF%BC%88%E4%BF%AE%E6%94%B9%E9%85%8D%E4%B9%90%E6%9C%89%E7%89%88%E6%9D%83%EF%BC%89%E5%8D%8E%E4%BA%BF%E5%88%9B%E6%96%B0%E5%85%AC%E5%8F%B8%E5%AE%A3%E4%BC%A0%E8%A7%86%E9%A2%9103-7.mp4',
        name: '华亿创新公司宣传视频'
    },
    {
        url: 'http://img.sportscv.cn/video/12%20%E5%8C%97%E4%BA%AC%E5%B7%A5%E4%BD%93%E7%81%AF%E5%85%89%E7%A7%80%E3%80%8A%E6%BB%9A%E5%8A%A8%E7%9A%84%E8%83%BD%E9%87%8F%E3%80%8B_%E7%BA%AF%E4%BA%AB%E7%89%88_1080p.mp4',
        name: '北京工体灯光秀《滚动的能量》'
    },
    {
        url: 'http://img.sportscv.cn/video/11%20%E5%86%AC%E5%A5%A5%E4%BC%9A-%E9%A6%96%E4%BD%93-%E5%8D%87%E6%97%97-%E5%8D%8E%E4%BA%BF%E5%88%9B%E6%96%B0.mp4',
        name: '冬奥会-首体-升旗-华亿创新'
    },
    {
        url: 'http://img.sportscv.cn/video/211203%E7%89%88%E6%AF%94%E8%B5%9B%E8%AE%BE%E5%A4%87%E9%9B%86%E6%88%90720p.mp4',
        name: '比赛设备集成产品介绍'
    },
    // {
    //     url: '11111',
    //     name: ''
    // },
];
let activeIndex = 0;
$(()=>{
    $('.video-item').click(function(){
        activeIndex = $(this).index();
        console.log(activeIndex);
        $('#video').attr('src', videoList[activeIndex].url);
        $(".video-list .active").removeClass('active');
        $(".video-list .video-item").eq(activeIndex).addClass('active');
    })
})